import { FIELD_BIND_TYPE, FIELD_BIND_TYPE_ENUM } from '@constants'
import { AutocompleteOption } from '@types'

import { BindType } from './types'

export const FIELD_BIND_VALUE_TYPE_OPTIONS: AutocompleteOption<BindType>[] = [
  { id: FIELD_BIND_TYPE_ENUM.FIELD as any, label: FIELD_BIND_TYPE.FIELD },
  { id: FIELD_BIND_TYPE_ENUM.STATIC as any, label: FIELD_BIND_TYPE.STATIC },
  { id: FIELD_BIND_TYPE_ENUM.JS as any, label: FIELD_BIND_TYPE.JS },
]

export const COMMAND_PARAMETER_TYPES_OPTIONS_WITHOUT_FIELD: AutocompleteOption<BindType>[] =
  FIELD_BIND_VALUE_TYPE_OPTIONS.filter(option => option.id !== (FIELD_BIND_TYPE_ENUM.FIELD as any))

export enum BODY_VIEW {
  ALL = 'all',
  CONFIGURED = 'configured',
}

export const COMMAND_PARAMS_FONT_SIZE = 14

export const SKELETON_ROWS = 3

export const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      bgcolor: '#fff',
      color: 'rgba(0,0,0,0.87)',
      border: '1px solid rgba(0,0,0,0.12)',
      boxShadow: 2,
      fontSize: COMMAND_PARAMS_FONT_SIZE,
    },
  },
  arrow: {
    sx: {
      color: '#fff',
      '&::before': {
        border: '1px solid rgba(0,0,0,0.12)',
      },
    },
  },
} as const
